/**
 * Recipes blog empty-tag filters.
 *
 * Tags that exist on published articles keep normal /tagged/ navigation.
 * Tags with no articles use ?filter= and show the section empty message
 * instead of Shopify's 404 for unknown tagged URLs.
 */
(function () {
  function getFilterFromUrl() {
    return new URLSearchParams(window.location.search).get('filter') || '';
  }

  function setActiveFilter(root, handle) {
    root.querySelectorAll('[data-recipe-filter]').forEach(function (link) {
      var linkHandle = link.getAttribute('data-recipe-filter');
      var isActive =
        (!handle && linkHandle === 'all') || (handle && linkHandle === handle);

      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function applyEmptyFilter(root, handle) {
    var emptyEl = root.querySelector('[data-recipe-filter-empty]');
    var showEmpty = !!handle;

    root.classList.toggle('recipes-blog--empty-filter', showEmpty);

    if (showEmpty) {
      setActiveFilter(root, handle);
    } else if (window.location.pathname.indexOf('/tagged/') === -1) {
      setActiveFilter(root, '');
    }

    if (emptyEl) emptyEl.hidden = !showEmpty;
  }

  function getSelectedMetafieldFilters(root) {
    return Array.prototype.reduce.call(
      root.querySelectorAll('[data-recipe-filter-checkbox]:checked'),
      function (filters, checkbox) {
        var field = checkbox.getAttribute('data-recipe-filter-field');
        if (!field) return filters;

        if (!filters[field]) filters[field] = [];
        filters[field].push(checkbox.value);
        return filters;
      },
      {}
    );
  }

  function hasSelectedMetafieldFilters(filters) {
    return Object.keys(filters).some(function (field) {
      return filters[field].length > 0;
    });
  }

  function parseRecipeMinutes(value) {
    var text = String(value || '').toLowerCase();
    var total = 0;
    var hasUnit = false;
    var hourMatch = text.match(/(\d+(?:\.\d+)?)\s*(hours?|hrs?|h)\b/);
    var minuteMatch = text.match(/(\d+(?:\.\d+)?)\s*(minutes?|mins?|m)\b/);

    if (hourMatch) {
      total += parseFloat(hourMatch[1]) * 60;
      hasUnit = true;
    }

    if (minuteMatch) {
      total += parseFloat(minuteMatch[1]);
      hasUnit = true;
    }

    if (!hasUnit) {
      total = parseFloat(text);
    }

    return Number.isFinite(total) ? total : 0;
  }

  function itemMatchesMetafieldFilters(item, filters) {
    return Object.keys(filters).every(function (field) {
      var selectedValues = filters[field];
      var itemValue = item.getAttribute('data-recipe-filter-' + field) || '';

      if (!selectedValues.length) return true;

      if (field === 'total-time') {
        var totalMinutes = parseRecipeMinutes(itemValue);

        if (!totalMinutes) return false;

        return selectedValues.some(function (range) {
          if (range === 'under-30') return totalMinutes < 30;
          if (range === '30-45') return totalMinutes >= 30 && totalMinutes < 45;
          if (range === '45-60') return totalMinutes >= 45 && totalMinutes < 60;
          if (range === '60-plus') return totalMinutes >= 60;
          return false;
        });
      }

      return selectedValues.indexOf(itemValue) !== -1;
    });
  }

  function getSelectedFilterLabels(root) {
    return Array.prototype.map.call(
      root.querySelectorAll('[data-recipe-filter-checkbox]:checked'),
      function (checkbox) {
        var label = checkbox.nextElementSibling;
        return label ? label.textContent.trim() : checkbox.value;
      }
    ).filter(Boolean);
  }

  function updateFilterSummary(root, hasFilters, visibleCount) {
    var summary = root.querySelector('[data-recipe-filter-summary]');
    var summaryCount = root.querySelector('[data-recipe-filter-summary-count]');
    var summaryTags = root.querySelector('[data-recipe-filter-summary-tags]');

    if (!summary) return;

    summary.hidden = !hasFilters;
    if (summaryCount) summaryCount.textContent = String(visibleCount);
    if (!summaryTags) return;

    summaryTags.innerHTML = '';
    if (!hasFilters) return;

    getSelectedFilterLabels(root).forEach(function (label) {
      var chip = document.createElement('span');
      chip.className = 'recipes-blog__filter-summary-tag';
      chip.textContent = label;
      summaryTags.appendChild(chip);
    });
  }

  function getVisibleStep(root) {
    return parseInt(root.dataset.visibleStep, 10) || 9;
  }

  function getVisibleLimit(root) {
    return parseInt(root.dataset.visibleLimit, 10) || getVisibleStep(root);
  }

  function setLoadMoreVisibility(root, hasFilters) {
    var button = root.querySelector('[data-recipe-load-more]');
    var pagination = root.querySelector('[data-recipe-list-pagination]');
    var items = root.querySelectorAll('[data-recipe-filter-item]');
    var shouldShow = !hasFilters && getVisibleLimit(root) < items.length;

    if (button) button.hidden = !shouldShow;
    if (pagination) pagination.hidden = !shouldShow;
  }

  function applyMetafieldFilters(root) {
    var filters = getSelectedMetafieldFilters(root);
    var hasFilters = hasSelectedMetafieldFilters(filters);
    var items = root.querySelectorAll('[data-recipe-filter-item]');
    var emptyEl = root.querySelector('[data-recipe-filter-empty]');
    var visibleLimit = getVisibleLimit(root);
    var visibleCount = 0;

    items.forEach(function (item, index) {
      var matchesFilters = !hasFilters || itemMatchesMetafieldFilters(item, filters);
      var isWithinVisibleLimit = hasFilters || index < visibleLimit;
      var isVisible = matchesFilters && isWithinVisibleLimit;

      item.hidden = !isVisible;
      if (matchesFilters) visibleCount += 1;
    });

    root.classList.toggle('recipes-blog--metafield-filter', hasFilters);
    setLoadMoreVisibility(root, hasFilters);
    if (emptyEl) emptyEl.hidden = !(hasFilters && visibleCount === 0);
    updateFilterSummary(root, hasFilters, visibleCount);
  }

  function closeFilterPanels(root) {
    root.querySelectorAll('[data-recipe-filter-group-panel]').forEach(function (panel) {
      panel.hidden = true;
    });

    root.querySelectorAll('[data-recipe-filter-group-trigger]').forEach(function (trigger) {
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openFilterPanel(root, group) {
    closeFilterPanels(root);

    root.querySelectorAll('[data-recipe-filter-group-panel]').forEach(function (panel) {
      var isTarget = panel.getAttribute('data-recipe-filter-group-panel') === group;
      panel.hidden = !isTarget;
    });

    root.querySelectorAll('[data-recipe-filter-group-trigger]').forEach(function (trigger) {
      var isTarget = trigger.getAttribute('data-recipe-filter-group-trigger') === group;
      trigger.classList.toggle('is-open', isTarget);
      trigger.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
    });
  }

  function openSelectedFilterPanel(root) {
    var selectedCheckbox = root.querySelector('[data-recipe-filter-checkbox]:checked');
    var panel = selectedCheckbox && selectedCheckbox.closest('[data-recipe-filter-group-panel]');

    if (!panel) {
      return;
    }

    openFilterPanel(root, panel.getAttribute('data-recipe-filter-group-panel') || '');
  }

  function initMultiFilter(root) {
    var triggers = root.querySelectorAll('[data-recipe-filter-group-trigger]');
    var checkboxes = root.querySelectorAll('[data-recipe-filter-checkbox]');
    var loadMoreButton = root.querySelector('[data-recipe-load-more]');

    root.dataset.visibleLimit = String(getVisibleStep(root));

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', function () {
        root.dataset.visibleLimit = String(getVisibleLimit(root) + getVisibleStep(root));
        applyMetafieldFilters(root);
      });
    }

    if (!triggers.length) {
      applyMetafieldFilters(root);
      return;
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var group = trigger.getAttribute('data-recipe-filter-group-trigger') || '';
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          closeFilterPanels(root);
        } else {
          openFilterPanel(root, group);
        }
      });
    });

    function resetFilters(event) {
      if (event) event.preventDefault();
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
      applyMetafieldFilters(root);
    }

    root.querySelectorAll('[data-recipe-filter-reset]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        resetFilters(event);
      });
    });

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        applyMetafieldFilters(root);
      });
    });

    openSelectedFilterPanel(root);
    applyMetafieldFilters(root);
  }

  function init(root) {
    var blogUrl = root.dataset.blogUrl || '';

    initMultiFilter(root);

    root.querySelectorAll('[data-recipe-empty-filter]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var handle = link.getAttribute('data-recipe-empty-filter') || '';
        if (!handle) return;

        var nextUrl = blogUrl + '?filter=' + encodeURIComponent(handle);
        var currentFilter = getFilterFromUrl();

        if (currentFilter === handle) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        window.location.assign(nextUrl);
      });
    });

    window.addEventListener('popstate', function () {
      applyEmptyFilter(root, getFilterFromUrl());
    });

    var initialFilter = getFilterFromUrl();
    if (initialFilter) {
      applyEmptyFilter(root, initialFilter);
    }
  }

  function boot() {
    document.querySelectorAll('[data-recipes-blog-filter]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
